// pages/CouleurMarque/typesChaussure/TypesChaussure.jsx
import React from 'react'
import { Card, Space, Tag, Progress, Tooltip } from 'antd'
import { 
    AppstoreOutlined, 
    ShoppingCartOutlined, 
    DollarOutlined 
} from '@ant-design/icons';

const TypesChaussure = ({ data = [], loading = false }) => {
    const maxVentes = data.length > 0 ? Math.max(...data.map(item => item.quantite_vendue || 0)) : 0;

    // Icônes par type de chaussure
    const getIcon = (categorie) => {
        switch(categorie?.toLowerCase()) {
            case 'escarpins': return '👠';
            case 'sandales': return '🩴';
            case 'mules': return '👡';
            case 'bottes': return '👢';
            case 'baskets': return '👟';
            default: return '👞';
        }
    };

    return (
        <Card className="marques" loading={loading}>
            <div className="marque_header">
                <Space>
                    <AppstoreOutlined style={{ fontSize: 18, color: '#1a1a1a' }} />
                    <h3>Types de Chaussures</h3>
                </Space>
                <Tag color="default">Top5 types / tendances</Tag>
            </div>

            <div className="marque_list">
                {data.length === 0 ? (
                    <div className="empty-state">
                        <p>Aucune donnée disponible</p>
                    </div>
                ) : (
                    data.map((item, index) => {
                        const percent = maxVentes > 0 ? (item.quantite_vendue / maxVentes) * 100 : 0;
                        
                        return (
                            <div key={index} className="marque_item">
                                <div className="marque_info">
                                    <div className="marque_name_wrapper">
                                        <span className="marque_icon">{getIcon(item.categorie)}</span>
                                        <span className="marque_name">{item.categorie}</span>
                                        <Tag 
                                            size="small" 
                                            color={percent > 50 ? 'success' : percent > 20 ? 'warning' : 'default'}
                                            className="marque_tag"
                                        >
                                            {item.pourcentage_ventes || 0}% des ventes
                                        </Tag>
                                    </div>
                                    <div className="marque_stats">
                                        <Tooltip title="Quantité vendue">
                                            <span className="stat">
                                                <ShoppingCartOutlined /> {item.quantite_vendue || 0}
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="Chiffre d'affaires">
                                            <span className="stat">
                                                <DollarOutlined /> {Number(item.chiffre_affaires || 0).toLocaleString()} $
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <Progress 
                                    percent={Math.round(percent)} 
                                    size="small" 
                                    status={percent > 50 ? "active" : "normal"}
                                    strokeColor={percent > 50 ? '#52c41a' : percent > 20 ? '#faad14' : '#ff4d4f'}
                                    showInfo={false}
                                />
                            </div>
                        );
                    })
                )}
            </div>
        </Card>
    )
}

export default TypesChaussure